import { render, staticRenderFns } from "./PoiPricesPiece.vue?vue&type=template&id=321b438f"
import script from "./PoiPricesPiece.js?vue&type=script&lang=js&external"
export * from "./PoiPricesPiece.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports